var RaphaelView = require('raphaelItemView'),
    _  = require('underscore'),
    Raphael = require('raphael'),
    ShapeUtils = require('../../../../models/shapeUtils'),
    BaseMoveFunctions = require('../../moveFns/baseMoveFnMixin'),
    DragHelper = require('../../moveFns/dragHelper'),
    ShapePageTransformModel = require('../../../../models/shapeTransformModel/shapePageTransformModel');


/*
* El now really like the wrapper ... there are inner view that affect this display ...
* ... explain ...
* */

var instVars = {

    noteCodesChannel: null,
    canvasChannel: null,
    model: null, // shared with the parent shape (and others that could share it)
    paper: null, // reference to the Raphael paper instance
    pageModel: null,
    shapePageTransformModel: null,

    // sub-views
    borderEl: null,
    innerEl: null, // view underneath el; el is the full size but only the border is visible
    textEl: null // maybe want this to be a subview ... though could be overkill,

};


var CodesView = RaphaelView.extend({

    initialize: function( options ) {

        _.extend( this, instVars, options );

        /* We only use the 'page level' transform for this shape  */
        this.shapePageTransformModel = new ShapePageTransformModel( ).initializeValues( this.pageModel, this.options.originalScale );

        // Take DPI of the underlying image into account.  1/4 inch from the page in physical dimensions.
        // TODO: put this on the codeUI model ...
        this.GUTTER = (0.25 * 96) * ( this.model.getPgDpi() / 96 );

        this.listenTo( this.model , 'updatePositionToMatchShapeView', this.placeAtDefaultPosition );
        this.listenTo( this.model , 'change:parentNoteIsActive', this._toggleActive );   // note: will ONLY  be call once per shape

        return this;

    },

    /*
    * Render empty, un-sized, rectangle path (el), borderEl, innerEl, and empty text el.
    * Also print and position on render since canvas loaded in no longer async --
    * Canvas shapes are NOW always rendered when the canvas in in the DOM.
    * */
    render: function( lineDelimitedCodes, shapeViewBox ) {

        this.el = this.paper.path().attr({
            stroke: 'none',
            fill: 'none'
        });

        /*
        * These inner ones are now rects -- could work with paths but this is just as easy as something funky was going on
        * innerEl outline in css -- it was much larger than the shape when it was a path; not so when a rect.
        * */
        this.borderEl = this.paper.rect()
            .attr(  this.model.getBorderElAttrs() );

        this.innerEl = this.paper.rect()
            .attr( this.model.getInnerElAttributes() );


        /* --- Text El --*/
        this.textEl = this.paper.text( 0, 0, '' );

        // Must set the line height prior to the attrs here -- this is for the lib fork.
        this.textEl.data('lineHeight', this.model.getTextLineHeight() );

        this.textEl.attr(  _.extend( {}, this.model.getTextElAttrs(), {
            text: lineDelimitedCodes
        }));

        // start with the transform applied
        this._updateTransformAndTransformView();

        if ( this.model.get('codesWerePositioned') ) {
            this.positionFromCoordinates();
        } else {
            this.placeAtDefaultPosition(shapeViewBox);
        }

        this._toggleActive( this.model, this.model.get('parentNoteIsActive') ) ;

        return this;

    },

    onUpdateShapeLayering: function( shapeEl ) {
        this.el.insertAfter( shapeEl );
        this.borderEl.insertAfter( this.el );
        this.innerEl.insertAfter( this.borderEl );
        this.textEl.insertAfter( this.innerEl );
    },

    /**
     * Note:
     * - must exist in DOM b/c of Raphael text bug ... hence events thrown to call this;
     *  - Update: this may not longer be an issue since the canvas in rendered synchrounously and the canvas should now be positioned in the DOM
     * - This expects the coordinates to be 'untransformed'.
     * - Coordinates here don't need to take conversion constant into account
     */
    positionFromCoordinates: function(coordinates) {

        var coords = coordinates || this.model.getBoxCoordinates(),
            topLeft = coords[0],
            topRight = coords[1],
            bottomLeft = coords[2],
            height = bottomLeft.y - topLeft.y,
            width = topRight.x - topLeft.x,
            sw = this.model.getStrokeWidth();


        // first position el
        this.el.setPathFromPtsArray( coords, 1 );

        // now position the subviews ... TODO: comment an explanation of why necessary
        this.borderEl.attr({
            x: topLeft.x + (sw / 2),
            y: topLeft.y + (sw / 2),
            width: width - sw,
            height: height - sw
        });

        this.innerEl.attr({
            x: topLeft.x + sw,
            y: topLeft.y + sw,
            width: width - (sw * 2),
            height: height - (sw * 2)
        });
        // now position the text relative to it (vertically align in center)


        // x position:
        //  push over once for the 'padding'
        //  push over only once for stroke-width (the stroke width is 'centered' -- only push over from the 'inner', not 'outer' portion')

        this.textEl.attr({
            x: topLeft.x + ( this.model.getPadding() + sw ),
            y: topLeft.y + ( height / 2 ) // centering vertically should account for any padding and border
        });

        // update & then apply the pageTransform
        this._updateTransformAndTransformView();

    },

    /**
     * Update the text in the box, resize the box while keeping it's top-left position
     * Tested: working on all rotations
     * Maybe better to remove and recreate the view, then don't need this here and this is easy.
     */
    onUpdateText: function( lineDelimitedCodes, shapeViewBox ) {

        // change the text so we can get it's size
        this.textEl.attr({
            text: lineDelimitedCodes
        });

        // if doesn't have position, use the existing logic to position at the default
        if ( !this.model.get('codesWerePositioned') ) {
            this.placeAtDefaultPosition(shapeViewBox);
            return;
        }

        // now calc the would be new coordinates to render correctly around the new text
        var oCodebox = this.el.getBBox(1); // use the untransformed -- then shouldn't need to convert

        // see notes in generating the default position
        var borderAndPadding = ( this.model.getPadding() + this.model.getStrokeWidth() ) * 2;

        var textBox = this.textEl.getBBox(1),
            shapeWidth = textBox.width + borderAndPadding,
            shapeHeight = textBox.height + borderAndPadding;

        var topLeft = {
            x: oCodebox.x,
            y: oCodebox.y
        };

        var newCoordinates = [
            {
                x: topLeft.x,
                y: topLeft.y
            },
            {
                x: topLeft.x + shapeWidth,
                y: topLeft.y
            },
            {
                x: topLeft.x + shapeWidth ,
                y: topLeft.y + shapeHeight
            },
            {
                x: topLeft.x,
                y: topLeft.y + shapeHeight
            }
        ];

        this.positionFromCoordinates( newCoordinates );

    },

    updateScale: function(scale) {
        this.shapePageTransformModel.setScale( scale );
        this._updateTransformAndTransformView();
    },


    /*
    * Position relative to parent shape on move / resize / initial render.
    * Assumes textEl is created.
    * Note: the parent shapes don't have transforms -- getBBox(1) wouldn't change things ... if they did the calc's here could be much simpler !!!
    * Note: canvasContainerRel shouldn't be an issue on initial render of existing shapes on canvas,
    * even though, this doesn't exist ( b/c these will have 'position' set ) and this wont be called.
    * *** However -- it will be for conversion ***
    * -------
    * Goal is to get what would be the untransformed coordinates to draw the box from coordinates.
    * The coordinates include border and stroke-width so these are taken into account when deriving for the size for the shape.
    * Note that they must be scaled to reflect the current page transform.
    * Handling positioning of the text inside the box will be done in the placement routine (so we don't
    * need to worry about offsetting for the position of the stroke width here (and the coordinates are all inclusive anyway);
    * Note: confirmed that stroke-width is not taken into account in Raphael.getBBox and DOM getBoundlingClientRect.
    * Will also give the first size to the box from the generated text if it hasn't been set yet  --
    * TODO: potential area for perf improvement if text box size is already know (esp for IE)
    * */
    placeAtDefaultPosition: function(shapeViewBox) {

        var shapePageTransformModel = this.shapePageTransformModel,
            scale = shapePageTransformModel.getScale(),
            rotation = shapePageTransformModel.getRotation(),
            strokeWidth = this.model.getStrokeWidth(),
            borderAndPadding = ( this.model.getPadding() + strokeWidth ) * 2 * scale,
            scaledStrokeWidth = strokeWidth * scale;

        var paperDims = this.canvasChannel.request('canvasContainerRel'),
            paperWidth = paperDims.x2,
            paperHeight = paperDims.y2,

            textBox = this.textEl.getBBox(),
            textWidth = textBox.width,
            textHeight = textBox.height,

            shapeWidth = textWidth + borderAndPadding,
            shapeHeight = textHeight + borderAndPadding,

            scaledGutter = this.GUTTER * scale,
            halfScaledStrokeWidth = scaledStrokeWidth / 2;

        var topLeft = {x: 0, y: 0},
            shapeExceedsCodeView;


        if ( rotation === 0) {

            // Take off half the total stroke-width b/c the stroke is centered on the shape in SVG
            shapeExceedsCodeView = shapeViewBox.x2 >=  paperWidth - scaledGutter - shapeWidth - halfScaledStrokeWidth;

            topLeft.x = shapeExceedsCodeView
                ? scaledGutter + halfScaledStrokeWidth
                : paperWidth - scaledGutter - shapeWidth - halfScaledStrokeWidth;

            topLeft.y = shapeViewBox.y;

        }

        else if (rotation === 90) {

            shapeExceedsCodeView = shapeViewBox.y2 >= paperHeight - scaledGutter - shapeHeight - halfScaledStrokeWidth;

            topLeft.x = shapeViewBox.x2 - shapeWidth;
            topLeft.y = shapeExceedsCodeView
                 ? scaledGutter + halfScaledStrokeWidth
                 : paperHeight - scaledGutter - shapeHeight - halfScaledStrokeWidth;

        }

        else if ( rotation === 270 ) {

            shapeExceedsCodeView = shapeViewBox.y <= scaledGutter + shapeHeight + halfScaledStrokeWidth;

            topLeft.x = shapeViewBox.x;
            topLeft.y = shapeExceedsCodeView
                ? paperHeight - scaledGutter - shapeHeight - halfScaledStrokeWidth
                : scaledGutter + halfScaledStrokeWidth;


        } else if ( Math.abs(rotation) === 180 ) {

            shapeExceedsCodeView = shapeViewBox.x < scaledGutter + shapeWidth + halfScaledStrokeWidth;

            topLeft.x = shapeExceedsCodeView
                ? paperWidth - shapeWidth - scaledGutter - halfScaledStrokeWidth
                : scaledGutter + halfScaledStrokeWidth;

            topLeft.y = shapeViewBox.y2 - shapeHeight;

        }

        // now create coordinates of the box from it -- combo'd with that of size of the text el (it was already printed),
        // to position el and textEl in positionFromCoordinates

        var boxCoordinates = [
            {
                x: topLeft.x,
                y: topLeft.y
            },
            {
                x: topLeft.x + shapeWidth,
                y: topLeft.y
            },
            {
                x: topLeft.x + shapeWidth,
                y: topLeft.y + shapeHeight
            },
            {
                x: topLeft.x,
                y: topLeft.y + shapeHeight
            }
        ];

        // potential optimization is cached on initial render, then adjusting on move ...

        // now normalize the pts back to no transformation applied (100% scale, no rotation)
        // TODO: can cache original center for perf and / or not provide it if rotation is 0
        var normalizedPts = ShapeUtils.getPtsWithoutTransformApplied(
            boxCoordinates, scale, rotation, this.pageModel.getOriginalCenterPtRotated()
        );

        // the above algorithm doesn't return the points in the 'rect' order; below is a quick fix
        if ( rotation !== 0)
            normalizedPts = ShapeUtils.getPtsInRectOrder( normalizedPts );

        this.positionFromCoordinates( normalizedPts );

    },


    // Now only called on entry on render -- no need parent should always be active and no need to disable drag;
    _toggleActive: function(model, parentNoteIsActive, options) {


        if (parentNoteIsActive) {

            this._enableDrag();

            // when a note is toggled active, it's set to the 'front', so update the z-positioning
            if (options && options.shapeViewEl) { // maybe want to break this out into a separate call ... it's also called on the initial render
                this.triggerMethod('updateShapeLayering', options.shapeViewEl);
            }

        }

    },
    /*
    * Set a drag event handler on this.el.
    * Capture and forward mousedown events of the subviews to el to trigger a dragStart on el.
    * */
    _enableDrag: function() {

        // Always disable first in case -- ran into case with find and redact after saving
        // Note where if drag was set twice, the drag-end event handle was set twice, which
        // Resulted in a run time error ( this.grab deleted )
        // While this doesn't hurt, we still need to refactor any 'toggling' active to be done
        // render of shapes !
        this._disableDrag();

        this.el
            .drag(
                function( dx, dy, x, y, e ) {

                    return this.moveMove( dx, dy, x, y, e, this.dragHelper, function() {

                        // may be able to consolidate that into use of shape el mixin ( assuming el or a set )
                        this.transform( 'T' + this.dragHelper.dx + ',' + this.dragHelper.dy ); // could put this login in the transform fn ... ( check for move )

                        this.noteCodesChannel.trigger( 'reasonCodeView.drag', this.model );

                    });

                },

                function( x, y, e ) {

                    var pageShapeTransformModel = this.shapePageTransformModel;

                    // TODO: if pass el or set, can use same as shapeMove fn's -- more clear code sharing
                    this.dragHelper = new DragHelper({
                        canvasBounds: this.canvasChannel.request('canvasContainerRel'),
                        dragOpacity: 0.5,
                        isTransformedShape: 1,
                        pageScale: pageShapeTransformModel.getScale(),
                        pageRotation: pageShapeTransformModel.getRotation(),
                        pageTransform: pageShapeTransformModel.getTransform()
                    });

                    return this.moveStart( x, y, e, this.dragHelper, function() {

                        this.model.set( 'codesWerePositioned', true );

                        // this.el already done now -- but this is like a set

                        // TODO: may be able to send these into helper as set ( see above ) -- set opacity of all
                        _.each( [ this.borderEl, this.innerEl, this.textEl], function(el) {
                            el.attr('opacity', 0.5);
                        });

                    });

                },

                function(e) {

                    return this.moveEnd( e, this.dragHelper, function() {

                        //--> want dx, dy for the client matrix adjustment on move end

                        // TODO: make this a callback with a default ?
                        _.each( [this.textEl, this.borderEl, this.innerEl ], function(el) {
                            el.attr({
                                x: el.attr('x') + this.dragHelper.invmDx,
                                y: el.attr('y') + this.dragHelper.invmDy,
                                opacity: 1.0
                            });
                        }, this);

                        /*
                         * handle the path element differently
                         * var nPath = Raphael.transformPath( boxEl.attr('path') , 't' + dx + ',' + dy );
                         *  note: transformPath ... so adds curves to the rect path, so below instead
                         * */
                        var oElPath = this.el.attr('path');
                        var newElPath = Raphael.fn.mapPathStraight( oElPath , Raphael.toMatrix(oElPath, 't' + this.dragHelper.invmDx + ',' + this.dragHelper.invmDy) );

                        this.el.attr({
                            'path': newElPath
                        });

                        this.transform();

                        this.noteCodesChannel.trigger( 'reasonCodeView.drag', this.model );

                        delete this.dragHelper; // ( now only primitives )

                    } );

                },
                this, this, this
            )
            .attr('cursor', 'move');

        // ( maybe we want to treat these as a set, but then we run into memory reference issues )
        // TODO: retest this ...
        _.each( [this.textEl,this.borderEl, this.innerEl ] , function(el) {

                el.mousedown( _.bind (function(e) {
                        e.preventDefault(); // disallow text selection (for text element)
                        e.stopPropagation();
                        this.el.trigger('mousedown', e); // start drag of el (which is underneath)
                    }, this))
                    .attr('cursor', 'move');

        }, this);

    },

    _disableDrag: function() {

        this.el
            .attr('cursor', 'inherit')
            .undrag();

        _.each( [this.textEl,this.borderEl, this.innerEl ] , function(el) {

            el.unmousedown()
                .attr('cursor', 'inherit');

        });

    },

    _updateTransformAndTransformView: function() {
        this.shapePageTransformModel.updateTransform( );
        this.transform();
    },

    // transform both el and all subviews
    // could potentially cache and uptimate getting the transform value
    transform: function(t) {

        var shapePgTransformModel = this.shapePageTransformModel;

        var trans = shapePgTransformModel.getTransform();

        if ( t ) {
            trans += t;
        }

        this.el.transform( trans );
        this.borderEl.transform( trans );
        this.innerEl.transform( trans );
        this.textEl.transform( trans );

        /*
        * Hack to fix stroke-width at different scales; see source code for transform --- it sets it back to the original.
        * First implementation didn't use this and always assumed a size of 1 px; changed when started storing stroke with as pts, and
        * then needed to adjust for image dpi ... this could now be larger and the may could manifest more.
        * Note: this will look a bit out of whack with the stroke width of the active redaction zones, which aren't scaled.
        * With an implementation of a viewbox, presumably wouldn't require.
        * */

        this.borderEl.attr('stroke-width', this.model.getStrokeWidth() * shapePgTransformModel.getScale() );

    },

    onBeforeDestroy: function() {

        this.stopListening();
        this._disableDrag();

        this.borderEl.remove();
        this.innerEl.remove();
        this.textEl.remove();
        this.el.remove();

    }

});


_.extend( CodesView.prototype, BaseMoveFunctions );


module.exports = CodesView;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/floatingCodes/codesView.js
 ** module id = 246
 ** module chunks = 0
 **/